import React, { useEffect, useState } from 'react'
import Page from '../../component/Page';
import { Autocomplete, Box, Button, CircularProgress, FormControl, Menu, MenuItem, Select, TextField } from '@mui/material';
import { MobileDatePicker } from '@mui/x-date-pickers';
import dayjs from 'dayjs';
import { useSelector } from 'react-redux';
import { getBranchList, getCatalogList } from '../setting/services/settingApi'
import api from '../../api/api'
import { saveAs } from 'file-saver';
import { REPORT_CONFIG } from './config'
import { getMaterialsList } from '../materials/services/api';
import { getItemMasterList } from '../stock/services/api';

export default function ReportSeedProduceCostByItem() {
    const [itemNo, setItemNo] = useState()
    const [items, setItems] = useState([])
    const [CatalogNo, setCatalogNo] = useState('')
    const [year, setYear] = useState('')
    const [yearerror, setYearerror] = useState('')
    const [error, setError] = useState('')

    const [reports, setReports] = useState([])
    const [loadingDownload, setloadingDownload] = useState(false);
    const [loading, setloading] = useState(false);

    const { profile } = useSelector(state => state.profile)
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    useEffect(() => {
        const getData = async () => {
            const res = await getItemMasterList()
            setItems(res)
        }
        getData()
        // LoadReport()

    }, [])

    async function getSeedProduceCostByItemReport(body, mode, format) {

        const url = `${REPORT_CONFIG.requests.getSeedProduceCostByItemReport.url}/${mode}`;


        let _params = '';


        let _c = '';

        let _year = '';
        let _format = '';



        if (body.c) {
            _c = '&itemNo=' + body.c;
        }

        if (body.year) {
            _year = '&year=' + body.year;
        }


        if (format) {
            _format = '&format=' + format;
        }
        _params = '?' + _c + _year + _format
        if (mode === 'file') {
            setloadingDownload(true)
            const res = await api.get(url + _params, { responseType: 'arraybuffer' })
            const data = res.data
            if (format) {
                const blob = new Blob([data], { type: 'application/pdf' });
                saveAs(blob, 'รายงานต้นทุนการผลิตรายพันธุ์');

            } else {
                const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                saveAs(blob, 'รายงานต้นทุนการผลิตรายพันธุ์');
            }
            setloadingDownload(false)
        } else {
            setloading(true)
            const res = await api.get(url + _params)
            const data = res.data.result
            setReports(data)
            setloading(false)
            setloadingDownload(false)
        }

    }
    async function LoadReport() {
        const body = {

            year: year || 66,

            c: itemNo?.ItemNo || undefined,

        };
        if (!itemNo) {
            return setError(true)
        } 
        if (!year || year.length !== 2) {
            return setYearerror(true)
        }
        setError(false)
        setYearerror(false)
        getSeedProduceCostByItemReport(body, 'data');



    }
    return (
        <div style={{ padding: '10px 30px' }}>
            <Page>
                <div class="container-fluid p-0">
                    <form >
                        <div class="row  no-gutters">

                            <div class="col-12 col-lg-2">
                                <div class="row no-gutters">
                                    <div class="col-12 header-row border-1 ">
                                        ตัวกรอง
                                    </div>
                                </div>
                                <div class="row no-gutters p-2 border-1">


                                    <div class="col-12">

                                        <label class="labelInput">พันธุ์ข้าว</label>

                                        {/* <Box className='backgroundField'>
                                            <FormControl variant="standard" fullWidth >
                                                <Select value={CatalogNo || '-'} onChange={e => setCatalogNo(e.target.value)} disableUnderline >
                                                    <MenuItem value='-'>-</MenuItem>
                                                    {Catalog?.map((x) => (
                                                        <MenuItem value={x?.CatalogNo}>{x?.CatalogName}</MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </Box> */}
                                        <Box className={`backgroundField ${error ? 'error' : ''}`} sx={{ marginBottom: '10px' }}>

                                            <Autocomplete

                                                fullWidth
                                                size='small'
                                                options={items}
                                                getOptionLabel={(option) => option?.ItemName}
                                                componentsProps={{
                                                    paper: {
                                                        sx: {
                                                            width: 500
                                                        }
                                                    }
                                                }}
                                                renderOption={(props, option) => (
                                                    <Box component="li" {...props} key={option.ItemNo}>
                                                        {option?.CatalogNo?.CatalogName} {option?.Option2} <span style={{ color: option?.Season === 'ฝน' ? '#0D9206' : 'brown', fontWeight: 'bold', margin: '0 10px' }}>{option?.Season}</span> {option?.Option1} {option?.Chemical}
                                                    </Box>
                                                )}
                                                value={itemNo}
                                                onChange={(event, newValue) => {
                                                    setItemNo(newValue)
                                                    // getLots(newValue?.ItemNo)
                                                }}
                                                onBlur={(event, newValue) => {
                                                    if (!event.target.value) {
                                                        setError(true)
                                                    } else {
                                                        setError(false)
                                                    }
                                                }}
                                                renderInput={(params) =>

                                                (
                                                    <TextField {...params} fullWidth variant="standard" />
                                                )}
                                            />
                                        </Box>


                                    </div>
                                    <div class="col-12">

                                        <label class="labelInput">ปี</label>

                                        {/* <Box className='backgroundField'>
                                            <FormControl variant="standard" fullWidth >
                                                <Select value={CatalogNo || '-'} onChange={e => setCatalogNo(e.target.value)} disableUnderline >
                                                    <MenuItem value='-'>-</MenuItem>
                                                    {Catalog?.map((x) => (
                                                        <MenuItem value={x?.CatalogNo}>{x?.CatalogName}</MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </Box> */}
                                        <Box className={`backgroundField ${yearerror ? 'error' : ''}`} sx={{ marginBottom: '10px' }}>
                                            <TextField value={year} onChange={e => setYear(e.target.value)} variant="standard" fullWidth
                                                onBlur={e => {
                                                    if (!e.target.value) {
                                                        setYearerror(true)
                                                    } else {
                                                        setYearerror(false)
                                                    }
                                                }}
                                                InputProps={{
                                                    disableUnderline: true,
                                                    // readOnly: true
                                                }}
                                                inputProps={{ maxLength: 2 }}
                                                onKeyPress={(event) => {
                                                    if (!/[0-9]/.test(event.key)) {
                                                      event.preventDefault();
                                                    }
                                                  }} 
                                                disabled={false}
                                                placeholder='ปี'
                                            />
                                        </Box>


                                    </div>


                                    <div class="col-12">
                                        <Button onClick={LoadReport} disabled={loading ? true : false} variant='contained' className="ButtomSearch">{loading ? <CircularProgress size={'18px'} color="inherit" /> : 'ค้นหา'} </Button>
                                    </div>

                                </div>
                            </div>
                            <div class="col-12 col-lg-10">
                                <div class="row no-gutters">
                                    <div class="col-12 d-flex justify-content-between header-row border-1 ">
                                        <div>
                                            รายงานต้นทุนการผลิตรายพันธุ์
                                        </div>
                                        <Button variant='contained'
                                            id="basic-button"
                                            aria-controls={open ? 'basic-menu' : undefined}
                                            aria-haspopup="true"
                                            aria-expanded={open ? 'true' : undefined}
                                            disabled={loadingDownload ? true : false}
                                            onClick={handleClick}>{loadingDownload ? <CircularProgress size={'18px'} color="inherit" /> : 'ดาวน์โหลด'}</Button>
                                        <Menu
                                            id="basic-menu"
                                            anchorEl={anchorEl}
                                            open={open}
                                            onClose={handleClose}
                                            MenuListProps={{
                                                'aria-labelledby': 'basic-button',
                                            }}
                                            PaperProps={{  
                                                style: {  
                                                  width: 100,  
                                                },
                                            }}
                                        >
                                            <MenuItem onClick={() => {
                                                const body = {

                                                    year: year || undefined,

                                                    c: itemNo?.ItemNo || undefined,

                                                };
                                                if (!itemNo) {
                                                    return setError(true)
                                                } 
                                                if (!year || year.length !== 2) {
                                                    return setYearerror(true)
                                                }
                                                setError(false)
                                                setYearerror(false)
                                                // setFormat('')
                                                getSeedProduceCostByItemReport(body, 'file')

                                                handleClose()
                                            }}>Excel</MenuItem>
                                            <MenuItem onClick={() => {
                                                const body = {

                                                    year: year || undefined,

                                                    c: itemNo?.ItemNo || undefined,

                                                };
                                                if (!itemNo) {
                                                    return setError(true)
                                                } 
                                                if (!year || year.length !== 2) {
                                                    return setYearerror(true)
                                                }
                                                setError(false)
                                                setYearerror(false)
                                                // setFormat('pdf')
                                                getSeedProduceCostByItemReport(body, 'file', 'pdf')

                                                handleClose()
                                            }}>Pdf</MenuItem>
                                        </Menu>
                                    </div>

                                </div>
                                <div class="row no-gutters border-1 pt-3">
                                    <div class="report col-12">
                                        <div class="table-responsive-sm" style={{ height: 'auto' }}>
                                            <table class="table table-bordered table-sm table-hover">
                                                <thead class="sticky-thead">
                                                    <tr>
                                                        <th scope="col" >ล็อตที่</th>
                                                        <th scope="col" >ปริมาณ (กิโกลรัม)</th>
                                                        <th scope="col" >ราคาต้นทุน (บาท/กิโลกรัม)</th>

                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {reports?.map((report, i) => (

                                                        <tr class="cp">
                                                            <td class="text-center">{report?.Lot}</td>
                                                            <td class="text-center">{report?.Qty.toLocaleString()}</td>
                                                            <td class="text-center">{report?.CostPrice.toLocaleString()}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                                {/* <thead class="sticky-tfooter">
                                                    <tr>
                                                        <th scope="col" colspan="9">รวม</th>
                                                        <th class="text-center">{sumValue?.Reason.Plant.toLocaleString()}</th>
                                                        <th class="text-center">{sumValue?.Reason.Sale.toLocaleString()}</th>
                                                        <th class="text-center">{sumValue?.Reason.Other.toLocaleString()}</th>
                                                    </tr>
                                                </thead> */}
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                {
                                    reports.length === 0 &&
                                    <div class="row" >
                                        <div class="col-12">
                                            <div class="not-found">
                                                ไม่พบข้อมูล
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>

                        </div>

                    </form>
                </div>
            </Page>
        </div>
    )
}
